function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import AccordionSpot from './../react-accordion-spot';

var AccordionSpotTabs = /*#__PURE__*/function (_AccordionSpot) {
  _inherits(AccordionSpotTabs, _AccordionSpot);

  var _super = _createSuper(AccordionSpotTabs);

  function AccordionSpotTabs(props) {
    var _this;

    _classCallCheck(this, AccordionSpotTabs);

    _this = _super.call(this, props);
    _this.renderHeadlineAsPartOfTitle = false;
    return _this;
  }

  _createClass(AccordionSpotTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-tabs"
      }, this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-title-".concat(index),
          className: "accordion-spot-tab ".concat(_this2.state.expandedElements.indexOf(index) !== -1 ? 'active' : 'passive'),
          onClick: function onClick(event) {
            _this2.onElementTitleClick(event, index);
          },
          onKeyPress: function onKeyPress(event) {
            _this2.onElementTitleClick(event, _this2.onExpandAllClick, index);
          },
          role: "button",
          tabIndex: index + 1
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-tab__title"
        }, element.title), _this2.renderHeadlineAsPartOfTitle && _this2.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-tab__header"
        }, element.header));
      })), this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-".concat(index),
          className: "accordion-spot-element ".concat(_this2.state.expandedElements.indexOf(index) !== -1 ? 'expand' : 'shrink'),
          "data-index": index + 1,
          onClick: _this2.state.expandedElements.indexOf(index) === -1 ? function (event) {
            _this2.onElementTitleClick(event, index);
          } : null
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__content"
        }, !_this2.renderHeadlineAsPartOfTitle && _this2.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__header"
        }, element.header), _this2.hasValue('body', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__body",
          dangerouslySetInnerHTML: {
            __html: element.body
          }
        })));
      }));
    }
  }]);

  return AccordionSpotTabs;
}(AccordionSpot);

AccordionSpotTabs.propTypes = {
  settings: PropTypes.shape({
    mobileBackgroundImage: PropTypes.string,
    desktopBackgroundImage: PropTypes.string,
    expandAllLabel: PropTypes.string,
    shrinkAllLabel: PropTypes.string,
    allowMultipleItemsExpanded: PropTypes.bool,
    expandItemOnLoad: PropTypes.number,
    expandAllOnLoad: PropTypes.bool,
    elements: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      header: PropTypes.string,
      body: PropTypes.string
    }))
  }),
  resolveDesktop: PropTypes.func.isRequired
};
AccordionSpotTabs.defaultProps = {
  settings: {
    mobileBackgroundImage: '',
    desktopBbackgroundImage: '',
    expandAllLabel: '',
    shrinkAllLabel: '',
    allowMultipleItemsExpanded: false,
    expandItemOnLoad: 0,
    expandAllOnLoad: false,
    elements: []
  }
};
export default AccordionSpotTabs;